export const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 12C20 7.6129 16.3871 4 12 4C7.58065 4 4 7.6129 4 12C4 16.4194 7.58065 20 12 20C16.3871 20 20 16.4194 20 12ZM11.0645 16.2581C10.871 16.4516 10.5161 16.4516 10.3226 16.2581L6.96774 12.9032C6.77419 12.7097 6.77419 12.3548 6.96774 12.1613L7.70968 11.4516C7.90323 11.2258 8.22581 11.2258 8.41935 11.4516L10.7097 13.7097L15.5484 8.87097C15.7419 8.64516 16.0645 8.64516 16.2581 8.87097L17 9.58065C17.1935 9.77419 17.1935 10.129 17 10.3226L11.0645 16.2581Z"
      fill="#8EDB23"
    />
  </svg>
);
